/* eslint-disable max-len */
import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { formatString, formatAndNotificateError } from 'utils';
import { DollarCircleOutlined } from '@ant-design/icons';
import { SubHeader, PreApprovedVoltzCard, Footer } from 'components';
import { Layout } from 'components/sdk';
import { useBusinessLoanContext } from 'contexts/BusinessLoanContext';
import { useQuery, useMutation } from '@apollo/client';
import useWindowDimensions from 'utils/hooks/useWindowDimensions';
import { ME, SAVE_LOAN_EVENT, SAVE_LOAN } from '../../graphql';

const { Content } = Layout;

const VoltzPreApproved = () => {
  const history = useHistory();
  const { width } = useWindowDimensions();
  const { currentContext } = useBusinessLoanContext();

  const [{ amount, installmentAmount, installments, paymentDay }, setValues] = useState({});

  const {
    data: { me: { firstName, currentBusiness: { loans = [] } = {} } = {} } = {},
    loading: meLoading,
  } = useQuery(ME);

  const [saveLoan, { loading: saveLoading }] = useMutation(SAVE_LOAN, {
    onError: (error) => formatAndNotificateError(error),
  });

  const [saveLoanEvent, { loading: saveLoanLoading }] = useMutation(SAVE_LOAN_EVENT, {
    onCompleted: () => history.push('/cadastro/status'),
    onError: (error) => formatAndNotificateError(error),
  });

  const loan = useMemo(
    () => loans.find(({ id }) => id === currentContext?.loan?.id),
    [loans, currentContext?.loan],
  );
  const state = useMemo(() => loan && 'pre-approved', [loan]);

  const loading = useMemo(() => saveLoading || saveLoanLoading, [saveLoading, saveLoanLoading]);

  const handleConfirmModalSubmit = async () => {
    await saveLoan({
      variables: {
        id: loan.id,
        paymentDay: Number(paymentDay),
      },
    });

    await saveLoanEvent({
      variables: {
        loanId: loan.id,
        amount,
        statusValue: 'awaiting-signature',
        installmentsCount: installments,
      },
    });
  };

  return (
    <Layout id="pre-approved-screen">
      <SubHeader
        title={
          state === 'type'
            ? `Olá, ${firstName}! Escolha uma opção de${width > 768 ? '\n' : ' '}crédito antes de prosseguir.`
            : `Olá, ${firstName}! Monte o seu crédito de${width > 768 ? '\n' : ' '}acordo com a necessidade do seu negócio.`
        }
        subtitle={
          state === 'type' &&
          'Você poderá escolher entre um empréstimo com trava de recebíveis, ou um empréstimo padrão.' +
            ' Clicando no banner informativo abaixo, você poderá entender como os recebíveis funcionam.'
        }
      />
      <Content>
        <Layout>
          <PreApprovedVoltzCard loan={loan} onChangeValues={setValues} />
        </Layout>
      </Content>

      <Footer
        loading={meLoading}
        leftContent={
          state === 'pre-approved' && (
            <div>
              <h4 className="no-margin-bottom">
                <strong className="secondary-text">VALOR DA PARCELA</strong>
              </h4>

              <div className="pre-approved-screen-footer-installment">
                <h1 className="no-margin-bottom secondary-text icon-container">
                  <DollarCircleOutlined />
                </h1>

                <h2 className="no-margin-bottom text-container">
                  <strong className="white-label-text">
                    {installmentAmount === undefined
                      ? 'Calculando...'
                      : formatString(installmentAmount, 'currency')}
                  </strong>
                </h2>
              </div>
            </div>
          )
        }
        okButton={{
          text: 'Finalizar ajustes',
          loading: loading || saveLoading,
          onClick: handleConfirmModalSubmit,
        }}
      />
    </Layout>
  );
};

export default VoltzPreApproved;
